/**
 * 导入模块
 */
import { showErrorOverlay, hideErrorOverlay } from './modules/overlay';

/**
 * 检查次数
 */
let checkCount: number = 0;

/**
 * 最大检查次数
 */
let maxChecks: number = 6;

/**
 * 检查轮训定时器
 */
let checkTimer: number | null = null;

/**
 * 当前根节点的元素ID
 */
let pageRootEleId: string = 'app';

/**
 * 清除检查间隔
 */
const clearCheckInterval = (): void => {
  if (checkTimer) {
    clearInterval(checkTimer);
    checkTimer = null;
  }
};

/**
 * 判断跟节点是否有内容
 */
const isHasElementInRootNode = (): boolean => {
  const rootEle: HTMLElement | null = document.getElementById(pageRootEleId);
  if (!rootEle) {
    console.warn('当前项目未找到入口的根节点，请确定元素根节点是否正确');
    return false;
  }
  if (!rootEle.innerHTML) {
    return false;
  }
  if (rootEle.children.length == 0) {
    return false;
  }
  const hasVueAttributes: boolean = rootEle.hasAttribute('data-v-app') || rootEle.getAttribute('data-v-app') !== null;
  const hasContent = rootEle.children.length > 0 || rootEle.textContent?.trim() !== '' || hasVueAttributes;
  return hasContent;
};

/**
 * 检查根元素内容
 */
const checkRootElementContent = (): void => {
  if (checkCount >= maxChecks) {
    clearCheckInterval();
    return;
  }
  checkCount++;
  const elementMounted: boolean = isHasElementInRootNode();
  if (elementMounted) {
    hideErrorOverlay();
  } else {
    showErrorOverlay();
  }
};

/**
 * 初始化检查
 */
const initContentCheck = (): void => {
  checkCount = 0;
  checkRootElementContent();

  // 设置定期检查
  if (!checkTimer) {
    checkTimer = window.setInterval(checkRootElementContent, 500);
  }
};

/**
 * 导出初始化方法
 */
const init = (rootEleId?: string): void => {
  if (rootEleId) {
    pageRootEleId = rootEleId;
  }

  /**
   * 网络状态监控
   */
  window.addEventListener('online', hideErrorOverlay);
  window.addEventListener('offline', showErrorOverlay);

  /**
   * 全局的加载监听事件
   */
  window.addEventListener('load', initContentCheck);
};

export { init, hideErrorOverlay };
